import * as React from 'react';

import AppState from '@webapp/store/state';
import DropdownCtrl from '../form/dropdown';
import { Category } from '@common/types/categories/category';
import { TrackLanguage } from '@common/types/release/track-language';
import { connect } from 'react-redux';

interface LanguageCtrlProps {
  id?: string;
  className?: string;

  value?: string;
  onChange: (value: string) => void;

  disabled?: boolean;
  error?: React.ReactNode;
}

interface StoreProps {
  languages: Category<TrackLanguage>[];
}

const mapStateToProps = (state: AppState) => ({
  languages: state.categories.lists.language || [],
});

export const LanguageCtrl: React.FC<LanguageCtrlProps & StoreProps> = ({
  ...props
}) => {
  const handleChange = (value: string) => {
    props.onChange(value);
  };

  const options = React.useMemo(() => props.languages
    .map((l) => ({ value: l.metadata.id, label: l.name }))
    .sort((a, b) => a.label.localeCompare(b.label)), [
      props.languages
    ]);

  return (
    <div className={props.className}>
      <DropdownCtrl
        id={props.id}
        title="Language"
        value={props.value}
        onChange={(value) => handleChange(value)}
        options={options}
        hasFilter
        filterLabel="Filter languages"
        disabled={props.disabled}
      />
      {props.error}
    </div>
  );
};

export default connect(mapStateToProps)(LanguageCtrl);
